import { pData, P_ORDER } from "@/data/content";

const W = 1080, H = 1080;
const GREEN = "#0D2A24", DARK = "#061B17", GOLD = "#D4AF37", GOLD3 = "#F1D98A", CREAM = "#F4EEE8";

const loadImage = (src) => new Promise((res) => { const img = new Image(); img.onload = () => res(img); img.onerror = () => res(null); img.src = src; });

const roundRect = (ctx, x, y, w, h, r) => {
  ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
};

const drawRadar = (ctx, values, primary, cx, cy, maxR) => {
  const angle = (i) => -Math.PI / 2 + (i * 2 * Math.PI) / 5;
  const pt = (r, i) => [cx + Math.cos(angle(i)) * r, cy + Math.sin(angle(i)) * r];
  const poly = (r) => { ctx.beginPath(); P_ORDER.forEach((_, i) => { const [x, y] = pt(r, i); i ? ctx.lineTo(x, y) : ctx.moveTo(x, y); }); ctx.closePath(); };
  ctx.lineWidth = 1.5; ctx.strokeStyle = "rgba(255,255,255,.16)";
  [1, 2, 3, 4, 5].forEach((l) => { poly((maxR * l) / 5); ctx.stroke(); });
  P_ORDER.forEach((_, i) => { const [x, y] = pt(maxR, i); ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(x, y); ctx.stroke(); });
  ctx.beginPath();
  P_ORDER.forEach((k, i) => { const [x, y] = pt(maxR * (values[k] / 5), i); i ? ctx.lineTo(x, y) : ctx.moveTo(x, y); });
  ctx.closePath(); ctx.fillStyle = "rgba(212,175,55,.28)"; ctx.fill(); ctx.lineWidth = 4; ctx.strokeStyle = GOLD3; ctx.stroke();
  P_ORDER.forEach((k, i) => {
    const [x, y] = pt(maxR * (values[k] / 5), i);
    ctx.beginPath(); ctx.arc(x, y, k === primary ? 11 : 8, 0, Math.PI * 2); ctx.fillStyle = GOLD3; ctx.fill(); ctx.lineWidth = 3; ctx.strokeStyle = GREEN; ctx.stroke();
    const [lx, ly] = pt(maxR + 52, i);
    ctx.textAlign = "center"; ctx.fillStyle = k === primary ? GOLD3 : "rgba(255,255,255,.85)";
    ctx.font = `800 26px Poppins, Arial, sans-serif`; ctx.fillText(pData[k].name, lx, ly + (i === 0 ? -6 : 10));
    ctx.font = `900 22px Poppins, Arial, sans-serif`; ctx.fillStyle = GOLD3; ctx.fillText(values[k].toFixed(1), lx, ly + (i === 0 ? 22 : 38));
  });
};

export async function renderResultCard({ primary, secondary, radar }) {
  await Promise.all([document.fonts.load('700 96px "Cormorant Garamond"'), document.fonts.load("800 26px Poppins")]).catch(() => {});
  const canvas = document.createElement("canvas"); canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");
  const bg = ctx.createLinearGradient(0, 0, W, H); bg.addColorStop(0, DARK); bg.addColorStop(0.6, GREEN); bg.addColorStop(1, "#143A30");
  ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = "rgba(212,175,55,.18)"; ctx.lineWidth = 2;
  [420, 320, 220].forEach((r) => { ctx.beginPath(); ctx.arc(900, 160, r, 0, Math.PI * 2); ctx.stroke(); });
  const glow = ctx.createRadialGradient(760, 640, 10, 760, 640, 420); glow.addColorStop(0, "rgba(212,175,55,.18)"); glow.addColorStop(1, "rgba(212,175,55,0)");
  ctx.fillStyle = glow; ctx.fillRect(0, 0, W, H);

  const logo = await loadImage("/assets/logo-dark.png");
  if (logo) ctx.drawImage(logo, 72, 62, 190, 95);
  ctx.textAlign = "left";
  ctx.fillStyle = GOLD; ctx.font = "800 22px Poppins, Arial, sans-serif"; ctx.letterSpacing = "4px";
  ctx.fillText("MY 5PS FOCUS PROFILE", 72, 220);
  ctx.letterSpacing = "0px";
  ctx.fillStyle = "#fff"; ctx.font = '700 64px "Cormorant Garamond", Georgia, serif';
  ctx.fillText("Right now, my journey", 72, 300);
  ctx.fillText("points to", 72, 368);
  ctx.fillStyle = GOLD3; ctx.font = '700 150px "Cormorant Garamond", Georgia, serif';
  ctx.fillText(pData[primary].name, 72, 505);
  ctx.fillStyle = "rgba(255,255,255,.72)"; ctx.font = "500 26px Poppins, Arial, sans-serif";
  ctx.fillText(pData[primary].q, 72, 578);
  ctx.fillStyle = "rgba(255,255,255,.55)"; ctx.font = "600 22px Poppins, Arial, sans-serif";
  ctx.fillText(`Secondary focus: ${pData[secondary].name}`, 72, 618);

  drawRadar(ctx, radar, primary, 780, 720, 190);

  let x = 72, y = 700;
  pData[primary].tags.slice(0, 4).forEach((t) => {
    ctx.font = "700 22px Poppins, Arial, sans-serif"; const w = ctx.measureText(t).width + 40;
    if (x + w > 540) { x = 72; y += 58; }
    roundRect(ctx, x, y, w, 46, 23); ctx.fillStyle = "rgba(255,255,255,.07)"; ctx.fill(); ctx.strokeStyle = "rgba(212,175,55,.35)"; ctx.lineWidth = 1.5; ctx.stroke();
    ctx.fillStyle = "rgba(255,255,255,.88)"; ctx.textAlign = "left"; ctx.fillText(t, x + 20, y + 31); x += w + 12;
  });

  ctx.fillStyle = "rgba(255,255,255,.55)"; ctx.font = "600 22px Poppins, Arial, sans-serif";
  ctx.fillText("Take the free 2-minute 5Ps quiz", 72, 960);
  ctx.fillStyle = GOLD3; ctx.font = "800 28px Poppins, Arial, sans-serif";
  ctx.fillText(window.location.host, 72, 998);
  ctx.fillStyle = "rgba(255,255,255,.5)"; ctx.font = "600 20px Poppins, Arial, sans-serif";
  ctx.fillText("From Campus to Corporate • 52 Lessons. 5Ps. One Journey. By Scott Tang.", 72, 1036);
  ctx.fillStyle = CREAM;
  return canvas;
}

export const canvasToBlob = (canvas) => new Promise((res) => canvas.toBlob(res, "image/png"));
